import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { InterfaceModelContent } from "@/components/interface/InterfaceModelContent";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";
import { AddInterfaceModelDialog } from "@/components/interface/AddInterfaceModelDialog";
import { useParams } from "react-router-dom";

const InterfaceModel = () => {
  const { businessTypeId } = useParams();
  const [isAddModelDialogOpen, setIsAddModelDialogOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState<any>(null);

  const { data: interfaceModels, isLoading } = useQuery({
    queryKey: ["interfaceModels", businessTypeId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("interface_models")
        .select("*, business_types(*)")
        .eq("business_type_id", businessTypeId);
      if (error) throw error;
      return data;
    },
    enabled: !!businessTypeId,
  });

  const sampleData = [
    {
      id: "1",
      data: {
        name: "Produit 1",
        unit: "Pièce",
        price: "1000 FCFA",
        status: "En stock",
        minQuantity: 5,
      },
      quantity: 10,
    },
    {
      id: "2",
      data: {
        name: "Produit 2",
        unit: "Carton",
        price: "5000 FCFA",
        status: "Stock bas",
        minQuantity: 3,
      },
      quantity: 5,
    },
    {
      id: "3",
      data: {
        name: "Produit 3",
        unit: "Kg",
        price: "2000 FCFA",
        status: "Rupture de stock",
        minQuantity: 2,
      },
      quantity: 0,
    },
  ];

  if (isLoading) {
    return (
      <DashboardLayout userType="admin">
        <div>Chargement...</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout userType="admin">
      <div className="space-y-6">
        <PageTitle
          title="Modèle d'interface"
          subtitle="Gérez les modèles d'interface pour chaque type d'entreprise"
        />

        {selectedModel && (
          <InterfaceModelContent
            interfaceModel={selectedModel}
            sampleData={sampleData}
            businessTypeId={businessTypeId}
            onSaleClick={(item) => {
              console.log("Sale clicked", item);
              toast.success("Vente enregistrée");
            }}
            onRestock={(item) => {
              console.log("Restock clicked", item);
              toast.success("Stock mis à jour");
            }}
            onLoss={(item) => {
              console.log("Loss clicked", item);
              toast.success("Perte enregistrée");
            }}
            onDelete={(item) => {
              console.log("Delete clicked", item);
              toast.success("Produit supprimé");
            }}
            onReturn={(item) => {
              console.log("Return clicked", item);
              toast.success("Retour enregistré");
            }}
          />
        )}

        <div className="flex justify-end">
          <Button onClick={() => setIsAddModelDialogOpen(true)}>
            <Plus className="w-4 h-4 mr-2" />
            Ajouter un modèle
          </Button>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {interfaceModels?.map((model: any) => (
            <Card
              key={model.id}
              className="p-4 cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => setSelectedModel(model)}
            >
              <h3 className="font-semibold mb-2">{model.name}</h3>
              <p className="text-sm text-gray-600">{model.description}</p>
            </Card>
          ))}
        </div>

        <AddInterfaceModelDialog
          open={isAddModelDialogOpen}
          onOpenChange={setIsAddModelDialogOpen}
        />
      </div>
    </DashboardLayout>
  );
};

export default InterfaceModel;